import {BaseIdCodeQuery} from "../../models/base.query";

export class LanguageQuery extends BaseIdCodeQuery {
  Iso2: string;

  static Columns() {
    return [...BaseIdCodeQuery.Columns(), 'Iso2'];
  }
}
